import { InformDialogTrigger, WelcomeDialogTrigger } from '@lingoda/student-f-free-trial';

export const PrivateDialogsTrigger = () => {
    return (
        <>
            <WelcomeDialogTrigger />
            <InformDialogTrigger />
        </>
    );
};
